import type { RoutePropsWithTitle } from '../types';

export const getPageTitle = (routes: RoutePropsWithTitle[], languageData: Record<string, string>) =>
  routes
    .map((route) => route.titleId || route.path)
    .filter(Boolean)
    .map((route) => languageData[`title.${route}`])
    .filter(Boolean)
    // eslint-disable-next-line unicorn/prefer-spread -- concat is more readable
    .concat(languageData['title.companyName'])
    .join(' | ');
